import { useFormat } from 'helpers/hooks/useFormat';

export const NoProductsFound = () => {
  const { formatMessage } = useFormat({ name: 'product' });

  return <p>{formatMessage({ id: 'noProductsFound', defaultMessage: 'No products found.' })}</p>;
};
